export default __webpack_public_path__ + "static/media/Stab and Detonate.c9125f7a.png";